import * as THREE from 'three';
import { WebCADGlobal } from "../..";
import { ThreeView } from "../../../view3d/webcad";
import { ExtrasType } from "../../../view3d/webcad/WebCadDefines";
import { ItemInfoCollection, PointCollection } from "../../collection";
import { DataInterface } from "./json/DataInterface";
import { Raycaster } from './Raycaster';
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../../Constants';
import { Room } from '../../item';
import WebCADUtil from '../WebCADUtil';

export class ApplyBeam {

    constructor() { }

    public apply(markinfo: ItemInfoCollection, data: DataInterface): void {
        const intersect = this.getIntersect(markinfo);
        console.log(intersect);
        if (!intersect) return;

        const point = intersect.point;
        const guid = intersect.object?.userData?.guid;
        const type = intersect.object?.userData?.type;

        const info = new ItemInfoCollection();
        info.id = data.itemId;
        info.floor = markinfo.floor;
        info.guid = WebCADGlobal.getGuid();
        info.x = 0;
        info.y = 0;

        const wallObj = this.getHitWall(guid);
        if (!wallObj) return;

        const beamWidth = markinfo.recognizeData.beamData.width;
        const dotList = this.getDotList(beamWidth, wallObj)
        info.dotList = dotList;

        // 梁成
        info.height = markinfo.recognizeData.beamData.height;

        WebCADGlobal.itemManager.createItem(info);
    }

    private getHitWall(guid: string): { obj: Room, index: number } {
        const itemList = [
            ...WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as Room[],
            ...WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as Room[],
            ...WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as Room[],
        ];
        for (let i = 0; i < itemList.length; i++) {
            const item = itemList[i];
            const index = item.itemInfo.dotList.findIndex((dot) => dot.guid === guid);
            if (index === -1) continue;

            return { obj: item, index: index };
        }
    }

    private isWallType(type: ExtrasType): boolean {
        return (type === ExtrasType.KABE) || (type === ExtrasType.KOSI);
    }

    /**
     * 衝突判定で取得したアイテム
     */
    protected getIntersect(iteminfo: ItemInfoCollection): THREE.Intersection {
        const isMeshTargetType = (mesh: THREE.Mesh): boolean => {
            return [
                ExtrasType.KABE, ExtrasType.KOSI
            ].some((type) => mesh?.userData?.type === type);
        }

        const pos = Raycaster.getPosition(iteminfo);
        const dir = Raycaster.getDirection(iteminfo);

        const raycaster = new THREE.Raycaster(pos, dir);
        const intersectlist = raycaster.intersectObjects(ThreeView.get().wcScene.me.children);

        for (let i = 0; i < intersectlist.length; i++) {
            const object = intersectlist[i]?.object;
            if (!object) continue;

            if (object?.userData?.type && isMeshTargetType(<THREE.Mesh>object)) {
                return intersectlist[i];
            }
        }
    }

    private getDotList(mmWidth: number, wallObj: { obj: Room, index: number }) {
        const dotList = wallObj.obj.itemInfo.dotList;
        const p1 = new THREE.Vector2(dotList[wallObj.index].x, dotList[wallObj.index].y);
        const nextIndex = (wallObj.index + 1) % dotList.length;
        const p2 = new THREE.Vector2(dotList[nextIndex].x, dotList[nextIndex].y);

        const beamWidth = WebCADUtil.convertMMToPix(mmWidth);
        const pointlist = this.createRectangleFromVectorClockwise(p1, p2, beamWidth);

        return [
            new PointCollection(pointlist[0].x, pointlist[0].y),
            new PointCollection(pointlist[1].x, pointlist[1].y),
            new PointCollection(pointlist[2].x, pointlist[2].y),
            new PointCollection(pointlist[3].x, pointlist[3].y)
        ];
    }

    private createRectangleFromVectorClockwise(p1: THREE.Vector2, p2: THREE.Vector2, distance: number): THREE.Vector2[] {
        const direction = p2.clone().sub(p1).normalize(); // p1 -> p2

        // (x, y)を右回り（時計回り）に90度回転 → (y, -x)
        const rightDirection = new THREE.Vector2(direction.y, -direction.x);

        const p3 = new THREE.Vector2().addVectors(p1, rightDirection.clone().multiplyScalar(distance));
        const p4 = new THREE.Vector2().addVectors(p2, rightDirection.clone().multiplyScalar(distance));

        // 長方形の4頂点
        return [p1, p2, p4, p3];
    }

}